import initialState from "./initialState";

export function ApprovalLimitsReducer(
  state = initialState.ApprovalLimitsInfo,
  action
) {
  switch (action.type) {
    case "SEARCH_APPROVAL_LIMITS_SELECTION_SET":
      return action.payload;
    default:
      return state;
  }
}
